// import enum
import { StatusEnum } from "@/enum/status.enum.js";

export const state = {
  filterGroup: {
    name: "",
    status: [],
    isFilter: false,
  },
};
export const mutations = {
  ADD_FILTER_GROUP: (state, data) => {
    state.filterGroup = data;
    state.filterGroup.isFilter = true;
  },
  CLEAR_FILTER_GROUP: (state) => {
    state.filterGroup = {
      name: "",
      status: [],
    };
  },
};
export const getters = {
  GET_FILTER_GROUP: (state) => {
    // console.log("GET_FILTER_GROUP", state.filterGroup);
    return state.filterGroup;
  },
};
export const actions = {
  ADD_FILTER_GROUP: ({ commit }, data) => {
    commit("ADD_FILTER_GROUP", data);
  },
  CLEAR_FILTER_GROUP: ({ commit }) => {
    commit("CLEAR_FILTER_GROUP");
  },
};
